var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "van-popup",
    {
      style: { height: "90vh" },
      attrs: { position: "bottom", round: "" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c("div", { staticClass: "health-info" }, [
        _c("div", { staticClass: "health-info__header" }, [
          _c("div", { staticClass: "health-info__title" }, [
            _vm._v("健康信息"),
          ]),
          _c(
            "div",
            {
              staticClass: "health-info__close",
              on: { click: _vm.handleClose },
            },
            [_c("i", { staticClass: "iconfont icon-close" })]
          ),
        ]),
        _c(
          "div",
          { staticClass: "health-info__content" },
          [
            _vm._l(_vm.form, function (section, key) {
              return _c(
                "div",
                { key: key, staticClass: "health-section" },
                [
                  typeof section === "object"
                    ? [
                        _c(
                          "div",
                          { staticClass: "section-header" },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v(_vm._s(_vm.getSectionTitle(key))),
                            ]),
                            _c(
                              "van-radio-group",
                              {
                                attrs: {
                                  direction: "horizontal",
                                  checked: section.has,
                                },
                                model: {
                                  value: section.has,
                                  callback: function ($$v) {
                                    _vm.$set(section, "has", $$v)
                                  },
                                  expression: "section.has",
                                },
                              },
                              [
                                _c(
                                  "van-radio",
                                  {
                                    attrs: {
                                      name: false,
                                      "checked-color": "$appcolor",
                                    },
                                  },
                                  [_vm._v("无")]
                                ),
                                _c(
                                  "van-radio",
                                  {
                                    attrs: {
                                      name: true,
                                      "checked-color": "$appcolor",
                                    },
                                  },
                                  [_vm._v("有")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        section.has
                          ? _c("div", { staticClass: "options-container" }, [
                              _c(
                                "div",
                                { staticClass: "options-grid" },
                                _vm._l(
                                  _vm.getOptions(key),
                                  function (option, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "option-item",
                                        class: {
                                          active:
                                            section.selected.includes(option),
                                        },
                                        on: {
                                          click: function ($event) {
                                            key === "nurseType"
                                              ? _vm.toggleSingleOption(
                                                  key,
                                                  option
                                                )
                                              : _vm.toggleOption(key, option)
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(option) + " ")]
                                    )
                                  }
                                ),
                                0
                              ),
                              false && key !== "nurseType"
                                ? _c(
                                    "div",
                                    { staticClass: "remark-input" },
                                    [
                                      _c("van-field", {
                                        attrs: {
                                          type: "textarea",
                                          placeholder: "请补充说明的详细情况",
                                          maxlength: 200,
                                          rows: "3",
                                          "show-word-limit": "",
                                          autosize: "",
                                        },
                                        model: {
                                          value: section.remark,
                                          callback: function ($$v) {
                                            _vm.$set(section, "remark", $$v)
                                          },
                                          expression: "section.remark",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            _c("div", { staticClass: "health-section" }, [
              _c(
                "div",
                { staticClass: "section-header" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("肝功能"),
                  ]),
                  _c(
                    "van-radio-group",
                    {
                      attrs: { direction: "horizontal" },
                      model: {
                        value: _vm.form.liverType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "liverType", $$v)
                        },
                        expression: "form.liverType",
                      },
                    },
                    [
                      _c(
                        "van-radio",
                        { attrs: { name: 0, "checked-color": "$appcolor" } },
                        [_vm._v("正常")]
                      ),
                      _c(
                        "van-radio",
                        { attrs: { name: 1, "checked-color": "$appcolor" } },
                        [_vm._v("异常")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "health-section" }, [
              _c(
                "div",
                { staticClass: "section-header" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("肾功能"),
                  ]),
                  _c(
                    "van-radio-group",
                    {
                      attrs: { direction: "horizontal" },
                      model: {
                        value: _vm.form.renalType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "renalType", $$v)
                        },
                        expression: "form.renalType",
                      },
                    },
                    [
                      _c(
                        "van-radio",
                        { attrs: { name: 0, "checked-color": "$appcolor" } },
                        [_vm._v("正常")]
                      ),
                      _c(
                        "van-radio",
                        { attrs: { name: 1, "checked-color": "$appcolor" } },
                        [_vm._v("异常")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          2
        ),
      ]),
      _c(
        "fixed-button",
        { on: { click: _vm.handleSubmit, emitEvent: _vm.handleSubmit } },
        [_vm._v("确定")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }